import { Grid, Typography } from "@mui/material";
import React from "react";
import Popup from "../../../components/Popup";
import OptionCard from "./OptionCard";

const PollPopup = ({ openPopup, setOpenPopup, pollDetails, setDetails }) => {
	/**
	 {
	"id": "4ccde6d1-6ef7-4188-ad39-bb0715f5ac29",
	"title": "First SEO Title",
	"description": "test desc",
	"og_title": "here is og title",
	"og_description": "nice",
	"poll_id": "828755e4-c684-4067-a78a-0eb9f9ca60c1",
	"created_at": "2023-11-25T20:39:34.000Z",
	"modified_at": "2023-11-25T20:43:06.000Z",
	"keywords": [
		{
			"id": "077b5f32-195f-4515-9cc7-85afb519b137",
			"keyword": "hmm",
			"poll_seo_id": "4ccde6d1-6ef7-4188-ad39-bb0715f5ac29"
		},
		{
			"id": "dfded3da-c13b-45b4-b36e-bd538ee3bfd9",
			"keyword": "looks",
			"poll_seo_id": "4ccde6d1-6ef7-4188-ad39-bb0715f5ac29"
		}
	]
}
	 */
	return (
		<Popup
			openPopup={ openPopup }
			setOpenPopup={ setOpenPopup }
			title={ pollDetails.poll_name }
			setDetails={ setDetails }>
			<Grid
				container
				alignItems='center'
				justifyContent='center'
			//sx={{ border: "1px dashed grey" }}
			>
				<Grid item container alignItems='center' direction='column'>
					<Typography variant='h5' component='block'>
						{ pollDetails.question }
					</Typography>
					<div style={ { display: "flex", justifyContent: "space-between", gap: "3rem", flexDirection: "row-reverse" } }>
						<Typography variant='subtitle2'>
							Campaign: { pollDetails.campaign_name }
						</Typography>
						<Typography variant='subtitle2'>
							Slug: { pollDetails.slug }
						</Typography>
						<Typography variant='subtitle2'>
							ID: { pollDetails.id }
						</Typography>
					</div>
					<Grid item container justifyContent='space-around' direction='row'>
						<Typography variant='overline'>
							Start Date: { pollDetails.start_date }
						</Typography>
						<Typography variant='overline'>
							{ pollDetails?.duration_name }
						</Typography>
						<Typography variant='overline'>
							End Date: { pollDetails.end_date }
						</Typography>
					</Grid>
				</Grid>
				<Grid container item alignItems='center' direction='column' rowGap={ 2 } sx={ { display: "flex", flexWrap: "wrap", justifyContent: "space-around", flexDirection: "row", padding: "1rem" } }>
					<OptionCard option={ pollDetails.poll_option } />
				</Grid>
				{pollDetails.seo && <Grid item container alignItems='center' direction='column' marginTop={ 5 }>
					<h4>SEO Details</h4>
					<div style={{width: "100%", display: "flex", flexDirection: "column"}}>
						{/* <div style={ { display: "flex", justifyContent: "space-between", gap: "3rem" } }> */}
							<Typography variant='p' fontSize={14} fontWeight={500} component='block'>
								Title: { pollDetails.seo?.title }
							</Typography>
							<Typography variant='p' fontSize={14} fontWeight={500} component='block'>
								OG Title: { pollDetails.seo?.og_title }
							</Typography>
						{/* </div> */}
						{/* <div style={ { display: "flex", justifyContent: "space-between", gap: "3rem" } }> */}
							<Typography variant='p' fontSize={14} fontWeight={500} component='block'>
								Description: { pollDetails.seo?.description }
							</Typography>
						{/* </div> */}
						{/* <div style={ { display: "flex", justifyContent: "space-between", gap: "3rem" } }> */}
							<Typography variant='p' fontSize={14} fontWeight={500} component='block'>
								OG Description: { pollDetails.seo?.og_description }
							</Typography>
						{/* </div> */}
					</div>
				</Grid>}
			</Grid>
		</Popup>
	);
};

export default PollPopup;
